import { render, staticRenderFns } from "./RDAinput.vue?vue&type=template&id=8e962c30&"
import script from "./RDAinput.vue?vue&type=script&lang=js&"
export * from "./RDAinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports